// extracted by mini-css-extract-plugin
export default {"button":"portfolio_button__QFOhL","portfolio":"portfolio_portfolio__7iOgh"};